export const THREE_DEC_ATTR_NAMES: readonly string[] = [
  'Wall Thickness',
  'Carbon Dioxide Mole Fraction',
  'Oxygen Mole Fraction',
  'Hydrogen Sulfide Mole Fraction',
  'Water Mole Fraction',
  'External Corrosion Rate',
  'Internal Corrosion Rate',
  'Isolation Section Volume',
  'Outside Diameter',
  'From Measure'
]

export const ONE_DEC_ATTR_NAMES: readonly string[] = [
  'Girth Weld Coating Extent',
  'Lightning Strike Density'
]

export const ZERO_DEC_ATTR_NAMES: readonly string[] = [
  'Blasting Susceptibility',
  'Charpy V-Notch Toughness',
  'CP System Performance',
  'Dependent Customer Count',
  'Depth of Cover',
  'Depth of Frost Line',
  'Earth Movement Susceptibility',
  'Flood Susceptibility',
  'Girth Weld Coating Disbondment',
  'Primary Coating Disbondment',
  'One Call Response Time',
  'Operating Pressure',
  'Operating Temperature',
  'Patrol Interval',
  'Reassessment Interval',
  'Soil Resistivity',
  'SSI',
  'Subsidence Susceptibility',
  'Tensile Strength',
  'Yield Strength'
]

export const formatWithPrecision = (
  v: number | string,
  decimals: number,
  mode: 'NaN' | 'Finite' = 'NaN'
): string => {
  const n = typeof v === 'string' ? parseFloat(v) : v

  const isValid =
    mode === 'NaN'
      ? !isNaN(n) // only checks for NaN
      : isFinite(n) // also excludes Infinity/-Infinity

  // ! this will round the number, which is often not wanted
  return isValid ? n.toFixed(decimals) : ''
}

export function removeSpacesFromList(list: ReadonlyArray<string>): string[] {
  return list.map((item) => item.replace(/\s+/g, ''))
}

export const decimalPrecision = (
  v: string | number | null | undefined,
  n: number
): string => {
  if (v === '' || v === null || v === undefined) {
    return ''
  }

  return Number(v).toFixed(n)
}

export const THREE_SET_RAW = new Set(removeSpacesFromList(THREE_DEC_ATTR_NAMES))
export const ONE_SET_RAW = new Set(removeSpacesFromList(ONE_DEC_ATTR_NAMES))
export const ZERO_SET_RAW = new Set(removeSpacesFromList(ZERO_DEC_ATTR_NAMES))
